var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplaceanswer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8084_39378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0413 3.12269C12.3184 3.39686 12.3184 3.84136 12.0413 4.11553L5.79729 10.2942C5.52021 10.5684 5.07104 10.5684 4.79396 10.2942L1.95604 7.48603C1.89017 7.42116 1.83785 7.34384 1.80215 7.25857C1.76644 7.17329 1.74805 7.08177 1.74805 6.98932C1.74805 6.89687 1.76644 6.80534 1.80215 6.72007C1.83785 6.63479 1.89017 6.55748 1.95604 6.49261C2.08975 6.3608 2.26996 6.28691 2.45771 6.28691C2.64546 6.28691 2.82567 6.3608 2.95938 6.49261L5.29563 8.80494L11.0374 3.12269C11.1711 2.99088 11.3513 2.91699 11.539 2.91699C11.7268 2.91699 11.9076 2.99088 12.0413 3.12269Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8084_39378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceanswer);
export default __webpack_public_path__ + "static/media/replace answer.72495c692698de418e44c287db22791a.svg";
export { ForwardRef as ReactComponent };